import { useEffect } from "react";
import { socket } from "socket";
import apiService from "services/apiService";

const STALE_AFTER_HIDDEN_MS = 60 * 1000;

export default function useSocketRevive() {
  useEffect(() => {
    let hiddenAt: number | null = null;

    const revive = (force: boolean) => {
      if (!socket.connected) {
        socket.connect();
        return;
      }
      if (force) apiService.reconnectSocket();
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        hiddenAt = Date.now();
        return;
      }
      const hiddenFor = hiddenAt === null ? 0 : Date.now() - hiddenAt;
      hiddenAt = null;
      revive(hiddenFor >= STALE_AFTER_HIDDEN_MS);
    };

    const onOnline = () => revive(true);

    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) revive(true);
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("online", onOnline);
    window.addEventListener("pageshow", onPageShow);
    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("online", onOnline);
      window.removeEventListener("pageshow", onPageShow);
    };
  }, []);
}
